module.exports = __webpack_public_path__ + "static/img/s2.7021497.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s2.png
// module id = yDhK
// module chunks = 1